module.exports = __webpack_public_path__ + "static/media/arrow_drop_up.55bbb20f.svg";